import styles from './BidCarouselButton.module.scss'
import cn from 'classnames'

export default function BidCarouselNext({ scrollNext, nextBtnEnabled }: any) {
  return (
    <button
      type="button"
      onClick={scrollNext}
      disabled={!nextBtnEnabled}
      className={cn(
        styles.button,
        `${!nextBtnEnabled ? 'cursor-not-allowed' : ''}`
      )}
    >
      <svg
        className={`embla__button__svg `}
        viewBox="0 0 40 40"
        fill="none"
        // stroke={!nextBtnEnabled ? '#CCC' : 'blue'}
        xmlns="http://www.w3.org/2000/svg"
      >
        <polyline
          points="10,0 30,20 10,40"
          strokeWidth="5"
          stroke={!nextBtnEnabled ? '#ababab' : '#000000'}
        />
        <defs>
          <filter
            id="filter0_d"
            x="0"
            y="0.5"
            width="40"
            height="40"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            />
            <feOffset dy="1" />
            <feGaussianBlur stdDeviation="2.5" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
            />
            <feBlend
              mode="normal"
              in2="BackgroundImageFix"
              result="effect1_dropShadow"
            />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect1_dropShadow"
              result="shape"
            />
          </filter>
        </defs>
      </svg>
    </button>
  )
}
